import { AlertProvider } from "./context/AlertContext";
import { ToastContainer } from "react-toastify";
import RoutesWrapper from "./routes";
import { ErrorAlert, SuccessAlert } from "./components";
import ConfirmAlert from "./components/Alert/ConfirmAlert";

function App() {
  return (
    <AlertProvider>
      <ToastContainer />
      <RoutesWrapper />
      <ErrorAlert autoClose={false} />
      <SuccessAlert autoClose={false} />
      <ConfirmAlert autoClose={false} />
    </AlertProvider>
  );
}

export default App;
